import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postRegisterTma,
  type PostRegisterTmaParams,
  type PostRegisterTmaResponse,
} from '@services/AuthService';

export type UsePostRegisterTmaParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostRegisterTmaResponse,
    unknown,
    string,
    PostRegisterTmaParams,
    PostRegisterTmaResponse
  >;
};

export const postRegisterTmaMutationKey = 'post-register-tma';

export const usePostRegisterTma = ({
  mutationOptions,
}: UsePostRegisterTmaParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostRegisterTmaResponse,
    unknown,
    string,
    PostRegisterTmaParams
  >(
    postRegisterTmaMutationKey,
    (_url, { arg }) => postRegisterTma(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
